import { render, staticRenderFns } from "./FormatEditorDebugTool.vue?vue&type=template&id=671ae756&scoped=true&"
import script from "./FormatEditorDebugTool.vue?vue&type=script&lang=ts&"
export * from "./FormatEditorDebugTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatEditorDebugTool.vue?vue&type=style&index=0&id=671ae756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671ae756",
  null
  
)

export default component.exports